import { render } from "./ReviewEntryComments.vue?vue&type=template&id=50641ff7&ts=true"
import script from "./ReviewEntryComments.ts?vue&type=script&lang=ts&external"
export * from "./ReviewEntryComments.ts?vue&type=script&lang=ts&external"

import "./ReviewEntryComments.vue?vue&type=style&index=0&id=50641ff7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__